import { render, staticRenderFns } from "./payrollbanks.vue?vue&type=template&id=8de42a5c"
import script from "./payrollbanks.vue?vue&type=script&lang=js"
export * from "./payrollbanks.vue?vue&type=script&lang=js"
import style0 from "./payrollbanks.vue?vue&type=style&index=0&id=8de42a5c&prod&lang=css"
import style1 from "./payrollbanks.vue?vue&type=style&index=1&id=8de42a5c&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports